export const SET_FILTER_ALL = 'SET_FILTER_ALL';
export const SET_FILTERED = 'SET_FILTERED';

export function setFilterAll(payload) {
    return {
        type: SET_FILTER_ALL,
        payload: payload
    };
}

export function setFiltered(payload) {
    return {
        type: SET_FILTERED,
        payload: payload
    };
}